var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField/SelectField';
import MenuItem from 'material-ui/MenuItem/MenuItem';

var LocaleSelector = function (_Component) {
    _inherits(LocaleSelector, _Component);

    function LocaleSelector(props, context) {
        _classCallCheck(this, LocaleSelector);

        var _this = _possibleConstructorReturn(this, (LocaleSelector.__proto__ || Object.getPrototypeOf(LocaleSelector)).call(this, props, context));

        _this.onLocaleChange = function (event, index, locale) {
            _this.setState({
                locale: locale
            });

            _this.props.onChange(locale, event);
        };

        var i18n = _this.context.d2.i18n;
        _this.getTranslation = i18n.getTranslation.bind(i18n);
        return _this;
    }

    _createClass(LocaleSelector, [{
        key: 'render',
        value: function render() {
            var localeMenuItems = [{ payload: '', text: '' }].concat(this.props.locales).map(function (locale, index) {
                return React.createElement(MenuItem, { key: index, primaryText: locale.name, value: locale.locale });
            });

            return React.createElement(
                SelectField,
                _extends({
                    fullWidth: true
                }, this.props, {
                    value: this.state && this.state.locale,
                    hintText: this.getTranslation('select_locale'),
                    onChange: this.onLocaleChange
                }),
                localeMenuItems
            );
        }
    }]);

    return LocaleSelector;
}(Component);

LocaleSelector.propTypes = {
    value: PropTypes.string,
    locales: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired
    })).isRequired,
    onChange: PropTypes.func.isRequired
};

LocaleSelector.contextTypes = {
    d2: PropTypes.object
};

export default LocaleSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2-ui/lib/i18n/LocaleSelector.component.js
// module id = 1110
// module chunks = 0